import { AuthContext } from '@/context/auth-context'
import { useContext, useRef } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import InviteAuth from './InviteAuth'
import InviteError from './InviteError'
import InviteAccept from './InviteAccept'

export default function InvitePage() {
  const { inviteId } = useParams()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const defaultEmail = queryParams.get('email') || undefined
  // Get auth context
  const { user } = useContext(AuthContext)

  // Track whether the user reached the accept step by creating a brand-new account (sign up) in this
  // invite flow. New sign-ups have no existing work to transfer, so they skip the join-confirmation
  // modal and accept directly. Users who signed in (or were already authenticated) keep the modal.
  const signedUpThisFlow = useRef(false)

  // If not logged in / anonymous, show sign in / sign up options
  if (!user || user.isAnonymous) {
    return <InviteAuth defaultEmail={defaultEmail} onSignUp={() => (signedUpThisFlow.current = true)} />
  }

  // If no invite ID
  if (!inviteId) {
    return <InviteError />
  }

  return <InviteAccept inviteId={inviteId} isNewSignUp={signedUpThisFlow.current} />
}
